import { render } from "./Binoculars.vue?vue&type=template&id=7b5c58ac"
import script from "./Binoculars.vue?vue&type=script&lang=js"
export * from "./Binoculars.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Binoculars.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b5c58ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b5c58ac', __exports__)) {
    api.reload('7b5c58ac', __exports__)
  }
  
  module.hot.accept("./Binoculars.vue?vue&type=template&id=7b5c58ac", () => {
    api.rerender('7b5c58ac', render)
  })

}


export default __exports__